export const flatten = (array, childrenKey = 'children', withParent = false) => {
  const result = []
  array.forEach((a, parentIndex) => {
    if (withParent) {
      result.push({
        ...a,
        parentIndex
      })
    }

    if (Array.isArray(a[childrenKey])) {
      a[childrenKey].forEach((item, childrenIndex) => result.push({
        ...item,
        parentIndex,
        childrenIndex
      }))
    }
  })

  return result
}

export const filterObjectByKeys = (needles, objHaystack) => {
  if (objHaystack) {
    return Object.keys(objHaystack)
      .filter(key => needles.includes(key))
      .reduce((obj, key) => {
        obj[key] = objHaystack[key]
        return obj
      }, {})
  }

  return null
}

export const randomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min

export const buildFilterTabData = (objParam) => {
  return Object.keys(objParam).map((item, index) => {
    return {
      id: index + 1,
      name: item.replace(/[#_]/g, ' '),
      expanded: false,
      checkedCount: 0,
      children: objParam[item].map(item => ({
        ...item,
        checked: false
      }))
    }
  })
}

export const buildFilterTabDataObj = (filterTabs) => {
  const obj = {}

  const filterTabsState = [...filterTabs]

  for (const filterTabItem of filterTabsState) {
    const selectedChildren = filterTabItem
      .children
      .filter(item => item.checked)

    if (!selectedChildren.length) continue

    obj[filterTabItem.name.replace(/ +/g, '_')] = selectedChildren
      .map(item => item.id)
      .join(',')
  }

  return obj
}

export const getLargestNumber = (images) => {
  const largestNumber = images.reduce((max, label) => {
    const match = label.match(/^Image (\d+)$/)
    if (match) {
      const number = Number(match[1])
      return number > max ? number : max
    }
    return max
  }, 0)

  return largestNumber
}
